export enum RelationshipToPolicyOwner {
  Self = "Self",
  Dependent = "Dependent",
  Other = "Other",
}

export enum InsuranceUploadType {
  primary = "primary",
  secondary = "secondary",
  medicaid_or_hmo = "medicaid_or_hmo",
}
